import {
  createRefund as publicCreateRefund,
  getRefund as publicGetRefund,
  queryRefunds as publicQueryRefunds,
  typedQueryRefunds as publicTypedQueryRefunds,
} from './payments-refunds-v1-refund-refunds.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  RefundQuery,
  RefundsQueryBuilder,
  typedQueryRefunds as universalTypedQueryRefunds,
} from './payments-refunds-v1-refund-refunds.universal.js';
import { onRefundCreated as publicOnRefundCreated } from './payments-refunds-v1-refund-refunds.public.js';
import { onRefundUpdated as publicOnRefundUpdated } from './payments-refunds-v1-refund-refunds.public.js';

function customQueryRefunds(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryRefunds(httpClient)(),
    typedQueryFunction: (query: RefundQuery) =>
      publicTypedQueryRefunds(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): RefundsQueryBuilder;
  function overloadedQuery(
    query: RefundQuery
  ): ReturnType<typeof universalTypedQueryRefunds>;
  function overloadedQuery(query?: RefundQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createRefund: MaybeContext<
  BuildRESTFunction<typeof publicCreateRefund> & typeof publicCreateRefund
> = /*#__PURE__*/ createRESTModule(publicCreateRefund);
export const getRefund: MaybeContext<
  BuildRESTFunction<typeof publicGetRefund> & typeof publicGetRefund
> = /*#__PURE__*/ createRESTModule(publicGetRefund);
export const queryRefunds: MaybeContext<
  BuildRESTFunction<typeof customQueryRefunds> & typeof customQueryRefunds
> = /*#__PURE__*/ createRESTModule(customQueryRefunds);
/** */
export const onRefundCreated: BuildEventDefinition<
  typeof publicOnRefundCreated
> &
  typeof publicOnRefundCreated = createEventModule(publicOnRefundCreated);
/** */
export const onRefundUpdated: BuildEventDefinition<
  typeof publicOnRefundUpdated
> &
  typeof publicOnRefundUpdated = createEventModule(publicOnRefundUpdated);

export {
  Status,
  Initiator,
  SortOrder,
  RejectionReason,
  WebhookIdentityType,
} from './payments-refunds-v1-refund-refunds.universal.js';
export {
  Refund,
  ExtendedFields,
  StatusInfo,
  CreateRefundRequest,
  CreateRefundResponse,
  GetRefundRequest,
  GetRefundResponse,
  QueryRefundsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryRefundsResponse,
  CursorPagingMetadata,
  Cursors,
  UpdateExtendedFieldsRequest,
  UpdateExtendedFieldsResponse,
  GetRefundabilityRequest,
  GetRefundabilityResponse,
  Refundability,
  RefundabilityDetailsOneOf,
  RefundDetails,
  RejectionDetails,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  SyncRefundRequest,
  SyncRefundResponse,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  RefundCreatedEnvelope,
  RefundUpdatedEnvelope,
  CreateRefundOptions,
  RefundsQueryResult,
  RefundsQueryBuilder,
  RefundQuerySpec,
} from './payments-refunds-v1-refund-refunds.universal.js';
export { utils } from './payments-refunds-v1-refund-refunds.universal.js';
export {
  StatusWithLiterals,
  InitiatorWithLiterals,
  SortOrderWithLiterals,
  RejectionReasonWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CreateRefundApplicationErrors,
  CommonQueryWithEntityContext,
  RefundQuery,
} from './payments-refunds-v1-refund-refunds.universal.js';
